import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import TenableInfraConfigListing from './TenableInfraConfigListing'
import TenableInfraCredentialsForm from './TenableInfraCredentialsForm'

export default function TenableInfraPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={TenableInfraCredentialsForm}
            PullConfigListingView={TenableInfraConfigListing}
        />
    )
}